import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["comment-image me-3", _ctx.isMenu ? 'd-flex profile-pic' : 'd-none d-md-flex' ])
  }, [
    _createElementVNode("img", {
      src: _ctx.imageSource,
      class: _normalizeClass([_ctx.cssClass, "img-fluid rounded-circle"]),
      alt: _ctx.userName,
      width: "30",
      height: "30"
    }, null, 10, _hoisted_1)
  ], 2))
}